var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49291 12.6175C7.6808 12.7802 7.95968 12.7802 8.14756 12.6175L15.4667 6.2789C15.8167 5.97584 15.6023 5.40094 15.1394 5.40094L11.4805 5.40094L11.4805 1.40094C11.4805 1.1248 11.2566 0.90094 10.9805 0.90094L4.98051 0.900941C4.70436 0.900941 4.48051 1.1248 4.48051 1.40094L4.48051 5.40094L0.501094 5.40094C0.0381511 5.40094 -0.176185 5.97584 0.173767 6.2789L7.49291 12.6175Z",
    fill: "#F44336"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownRed);
export default __webpack_public_path__ + "static/media/Down Red.4ba8b7f7f8dc81faade8dac6d3f21577.svg";
export { ForwardRef as ReactComponent };